import React from "react";
import "./PlaidScreen.css";
import plaidIllustration from "../../assets/plaid.svg";
import { TextCss } from "../../components/GlobalCss/TextCss";
import { GetImages } from "../../utils/GetImages";

const PlaidScreen: React.FC = () => {
  return (
    <div className="plaid-screen-container">
      {/* Top Section with Illustration */}
      <div className="plaid-top-section">
        <div className="plaid-illustration-wrapper">
          <img src={GetImages.Plaid} alt="Plaid illustration" className="plaid-illustration" />
        </div>
        <p className={TextCss.black.heading_600_16}>Connect your account with Plaid</p>
      </div>

      {/* Bottom Card Section */}
      <div className="plaid-content-card">
        {/* Connect in seconds section */}
        <div className="plaid-feature-block">
          <div className="plaid-icon-wrapper">
          <img src={GetImages.Lightening} alt="Plaid illustration" className="plaid-icon color-white-icon" />
     
          </div>
          <div className="plaid-feature-content">
            <p className={TextCss.black.sub_heading_600_14}>Connect in seconds</p>
            <p className={TextCss.black.normal_text_400_14}>
              8000+ apps trust Plaid to quickly connect to financial institutions
            </p>
          </div>
        </div>

        {/* Keep your data safe section */}
        <div className="plaid-feature-block">
          <div className="plaid-icon-wrapper">
          <img src={GetImages.shield} alt="Plaid illustration" className="plaid-icon color-white-icon" />
          </div>
          <div className="plaid-feature-content">
            <p className={TextCss.black.sub_heading_600_14}>Keep your data safe</p>
            <p className={TextCss.black.normal_text_400_14}>
              Plaid uses best-in-class encryption to help protect your data
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaidScreen;
